window.$ = window.jQuery = require('jquery')
// const $ = window.$